import React, { useCallback, useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ItemContent, ItemTitle } from '../DarkWebStyles';
import { DataItem, DataItemText, DeleteIcon } from '../DarkWebModal/DarkWebModalStyles';
import { deleteIban } from '../../../../ExperianActions';
import StopMonitoringModal from '../StopMonitoringModal/StopMonitoringModal';
import ExperianContext from '../../../../ExperianContext';

const Ibans = ({ title, data }) => {
  const [ibanToDelete, setIbanToDelete] = useState(null);

  const { clientId, subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();

  const onConfirmCallback = useCallback(async () => {
    await dispatch(deleteIban(clientId, subscriberId, ibanToDelete.Label));
    setIbanToDelete(null);
  }, [clientId, subscriberId, ibanToDelete, dispatch]);

  return (
    data &&
    data.length > 0 && (
      <>
        <div>
          <ItemTitle>{title}</ItemTitle>
          <ItemContent>
            {data.map(iban => (
              <DataItem key={iban.Label}>
                <DeleteIcon onClick={() => setIbanToDelete(iban)} />
                <DataItemText>{iban.Iban}</DataItemText>
              </DataItem>
            ))}
          </ItemContent>
        </div>
        {!!ibanToDelete && (
          <StopMonitoringModal
            onConfirm={onConfirmCallback}
            onRequestClose={() => setIbanToDelete(null)}
          >
            Are you sure you want to stop monitoring:
            <br />
            IBAN {ibanToDelete.Iban}?
          </StopMonitoringModal>
        )}
      </>
    )
  );
};

export default Ibans;
